import { BasicUser } from "types/topicflow";

export type CalibrationGroupFormType = {
  id?: number | null;
  name: string;
  users: BasicUser[];
  managers: BasicUser[];
  approvers: BasicUser[];
};

export enum CalibrationGroupsModalView {
  LIST = "list",
  FORM = "form",
}

export type UsersByCalibrationGroup = Record<
  number,
  { name: string; users: BasicUser[] }
>;
